const DefaultChecked = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 30 30" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 5C7.23858 5 5 7.23858 5 10V20C5 22.7614 7.23858 25 10 25H20C22.7614 25 25 22.7614 25 20V10C25 7.23858 22.7614 5 20 5H10ZM19.7378 12.8378C20.0969 12.4648 20.0857 11.8713 19.7128 11.5122C19.3398 11.1531 18.7463 11.1643 18.3872 11.5372L13.6823 16.4231L11.646 14.0735C11.3069 13.6822 10.7148 13.6399 10.3235 13.979C9.93223 14.3181 9.88994 14.9102 10.229 15.3015L12.9374 18.4265C13.1098 18.6255 13.358 18.7428 13.6213 18.7497C13.8845 18.7566 14.1385 18.6525 14.3211 18.4628L19.7378 12.8378Z"
      fill="#9DD2B0"
    />
  </svg>
)

export default DefaultChecked
